var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57349 3.11657C8.68398 2.98398 8.66607 2.78693 8.53348 2.67644C8.40089 2.56595 8.20384 2.58387 8.09335 2.71645L5.84724 5.41179C5.39606 5.95321 5.07867 6.3329 4.80338 6.58149C4.5345 6.82428 4.34895 6.90145 4.16676 6.90145C3.98456 6.90145 3.79901 6.82428 3.53014 6.58149C3.25484 6.3329 2.93745 5.95321 2.48627 5.41179L1.90683 4.71645C1.79634 4.58387 1.59928 4.56595 1.4667 4.67644C1.33411 4.78693 1.3162 4.98398 1.42669 5.11657L2.02222 5.8312C2.45358 6.34885 2.79903 6.76341 3.11126 7.04536C3.43379 7.3366 3.76348 7.52645 4.16676 7.52645C4.57003 7.52645 4.89972 7.3366 5.22225 7.04536C5.53448 6.76341 5.87993 6.34886 6.31129 5.83122L8.57349 3.11657Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.ab3e15a1054950d57183abca91e92d62.svg";
export { ForwardRef as ReactComponent };